import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleWork from '../../components/Work';

import workBG from '../../assets/img/work/work-bg.jpg';
import titleImg from '../../assets/img/category/title.svg';
import iconImg1 from '../../assets/img/work/work-1.svg';
import iconImg2 from '../../assets/img/work/work-2.svg';

const Work = () => {
  return (
    <div
      className="it-wrok-area it-wrok-bg pt-120 pb-90"
      style={{ backgroundImage: `url(${workBG})` }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <SectionTitle
              itemClass="it-course-title-box mb-60 text-center"
              subTitleClass="it-section-subtitle-5"
              subTitle="How To Join"
              titleClass="it-section-title-3"
              title="Join In 3 Steps"
              titleImage={titleImg}
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleWork
              itemClass="it-work-item text-center"
              iconImage={iconImg1}
              title="Choose A Program"
              to="/programs"
              description="Pick a degree, diploma, certificate or short course that fits your goal."
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleWork
              itemClass="it-work-item active text-center"
              iconImage={iconImg2}
              title="Check Entry Rules"
              to="/faq"
              description="Degrees need A/L passes. Some courses ask for work experience."
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleWork
              itemClass="it-work-item text-center"
              iconImage={iconImg2}
              title="Apply And Start"
              to="/apply"
              description="Send your form by email, post or in person, then begin your classes."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Work;
